import { useCallback } from 'react';
import { useObservableCacheItem } from '../../cache/observable-cache-hooks';
import { useObservableCache } from '../../cache/observable-cache-provider';
import { DirectConnectMachine } from '../model/direct-connect.model';

export const DIRECT_CONNECT_MACHINES_CACHE_KEY = 'dc-machines';

const useDirectConnectCachedMachines = (): DirectConnectMachine[] => {
  return useObservableCacheItem(DIRECT_CONNECT_MACHINES_CACHE_KEY) ?? [];
};

const useGetDirectConnectCachedMachine = (
  id: string
): DirectConnectMachine | undefined => {
  const machines = useDirectConnectCachedMachines();
  return machines.find((m) => m.id === id);
};

const useRemoveDirectConnectCachedMachine = (): ((id: string) => void) => {
  const cache = useObservableCache();

  const callback = useCallback(
    async (id: string) => {
      await cache.filterList<DirectConnectMachine>(
        DIRECT_CONNECT_MACHINES_CACHE_KEY,
        (entry) => entry.id !== id
      );
    },
    [cache]
  );

  return callback;
};

const useAddDirectConnectCachedMachine = (): ((
  machine: DirectConnectMachine
) => void) => {
  const cache = useObservableCache();

  const callback = useCallback(
    async (machine: DirectConnectMachine) => {
      await cache.addItemToList(
        DIRECT_CONNECT_MACHINES_CACHE_KEY,
        machine,
        (item, entry) => item.id === entry.id
      );
    },
    [cache]
  );

  return callback;
};

export {
  useAddDirectConnectCachedMachine,
  useDirectConnectCachedMachines,
  useGetDirectConnectCachedMachine,
  useRemoveDirectConnectCachedMachine,
};
